import { takeEvery, takeLatest, call, put } from 'redux-saga/effects';
import actionTypes from 'redux/actionTypes';
import {
	getRefreshTimeSuccess,
	getRefreshTimeFailure,
	canUserCreateReportSuccess,
	canUserCreateReportFailure
} from './ReportSettings.actions';
import APIURLPATH from 'constants/apiconstants';
import { postData } from 'service/postData.service';
import { getData } from 'service/getData.service';

export function* getRefreshTimeSaga(request) {
	try {
		const response = yield call(postData, APIURLPATH.REFRESH_TIME, request.payload);

		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}

		yield put(getRefreshTimeSuccess(response?.json));
	} catch (error) {
		yield put(getRefreshTimeFailure(505));
	}
}

export function* canUserCreateReport(request) {
	try {
		const response = yield call(getData, APIURLPATH.CAN_USER_CREATE_REPORT, request.payload);
		if (response?.statusCode >= 400) {
			throw new Error(response?.statusCode);
		}
		yield put(
			canUserCreateReportSuccess({
				canCreateAdhocReports: response?.json?.canCreateAdhocReports,
				canCreateScheduledReports: response?.json?.canCreateScheduledReports
			})
		);
	} catch (error) {
		yield put(canUserCreateReportFailure(505));
	}
}

export function* reportSettingsSagaWatcher() {
	yield takeEvery(actionTypes.GET_REFRESH_TIME, getRefreshTimeSaga);
	yield takeLatest(actionTypes.USER_CAN_CREATE_REPORT, canUserCreateReport);
}
